export function usePrefetchImages(): { isLoading: Ref<boolean>; prefetchImages: (imageUrls: string[]) => void } {
    const isLoading: Ref<boolean> = ref(true);

    const prefetchImages = (imageUrls: string[]): void => {
        isLoading.value = true;
        const loadPromises: Promise<void>[] = imageUrls.map((url: string) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = url;
                img.onload = () => resolve();
                img.onerror = (error: any) => reject(error);
            });
        });

        Promise.all(loadPromises)
            .then(() => {
                isLoading.value = false;
            })
            .catch((error: any) => {
                console.error('Failed to prefetch images:', error);
                isLoading.value = false;
            });
    };

    return {isLoading, prefetchImages};
}